import { createBrowserHistory } from 'history';
//import createHashHistory from 'history/createHashHistory'

export default createBrowserHistory({basename: '/'});

